import clsx, { type ClassValue } from 'clsx';

/**
 * Concatenate Tailwind class names safely (clsx wrapper).
 * Use this everywhere instead of template literals for conditional classes.
 */
export function cn(...inputs: ClassValue[]): string {
  return clsx(inputs);
}
